<template>
    <div class="wrap">
        <div class="view">
            <view-port class="video-element self" :class="{mobile: isMobile, active}" @click.native="handleUnblur" :is-mobile="isMobile" :stream="self" :muted="true" :self="true" :unflip="screenShare"/>
            <view-port class="video-element" :class="{mobile: isMobile}" :is-mobile="isMobile" :stream="other" :muted="mute"/>
        </div>
        <div class="end-call" @click="endCall">
            <span class="material-icons" @click.stop="endCall">
                call_end
            </span>
        </div>
        <div class="menu">
            <control-bar 
             :muted="muteSelf"
             :screen-share="screenShare"
             :can-share-screen="canShareScreen"
             :hide-video="hideVideo"
             :deafen="mute"
             :dummy-video="dummyVideo"
            :dummy-audio="dummyAudio"
             @mute="handleMute"
             @hide-video="handleHideVideo"
             @deafen="handleDeafen"
             @screen-share="handleScreenShare"
            ></control-bar>
        </div>
    </div>
</template>

<script>
import ViewPort from './ViewPort'
import isMobileMixin from "../../mixins/isMobileMixin"
import ControlBar from './ControlBar'
export default {
    components: {
        ViewPort,
        ControlBar
    },
    props: {
        self: MediaStream,
        other: MediaStream,
        screenShare: Boolean,
        hideVideo: Boolean,
        muteSelf: Boolean,
        canShareScreen: Boolean,
        dummyVideo: Boolean,
        dummyAudio: Boolean
    },
    mixins: [isMobileMixin],
    data () {
        return {
            mute: false,
            active: false,
        }
    },
    methods: {
        handleScreenShare (val) {
            this.$emit('share-screen', val)
        },
        handleMute (val) {
            this.$emit('mute', val)
        },
        handleHideVideo (val) {
            this.$emit('hide-video', val)
        },
        handleDeafen (val) {
            this.mute = val
        },
        handleUnblur () {
            if (!this.isMobile) {
                return
            }
            this.active = !this.active
        },
        endCall () {
            this.$emit('end-call')
        }

    }
}
</script>

<style lang="scss" scoped>
.wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0, .7);
    z-index: 16;
}
.view {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 68px);
    position: relative;
}
.menu {
    width: 100%;
    height: 68px;
}
.video-element {
    box-sizing: border-box;
    padding: 0 2%;
    width: 50%;
    max-height: 90%;
    transition: opacity .7s ease;
    height: 100%;
    &.mobile {
        width: 100%;
        z-index: 1
    }
    &.self {
        &.mobile {
            width: 30%;
            z-index: 2;
            opacity: .2;
            height: unset
        }
        &.active {
            opacity: 1;
        }
    }
}
.end-call {
    position: absolute;
    bottom: 130px;
    left: 50%;
    transform: translateX(-50%);
    background: #bd1818;
    height: 48px;
    width: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    user-select: none;
    z-index: 3;
    cursor: pointer;
    .material-icons {
        color: #fff;
        font-size: 2rem;
    }
}
</style>